<template>
    <div>
        <div v-if="step == 'form'">

            <div class="form-group form__group" v-bind:class="{ 'is-invalid': errors.name }">
                <input
                    type="text"
                    class="form-control form-control--white"
                    placeholder="Ваше имя"
                    v-model="contact.name">
                <p class="invalid-feedback" v-if="errors.name">
                    {{ errors.name.join(', ') }}
                </p>
            </div>
            <div class="form-group form__group" v-bind:class="{ 'is-invalid': errors.phone }">
                <input type="text" class="form-control form-control--white" v-model="contact.phone"
                    v-mask="'+7(###)###-##-##'" placeholder="+7(xxx)xxx-xx-xx">
                <p class="invalid-feedback" v-if="errors.phone">
                    {{ errors.phone.join(', ') }}</p>
            </div>

            <div class="form-group form__group" v-bind:class="{ 'is-invalid': errors.email }">
                <input
                type="text"
                placeholder="Email для ответа"
                class="form-control form-control--white"
                v-model="contact.email">
                <p class="invalid-feedback" v-if="errors.email">
                    {{ errors.email.join(', ') }}</p>
            </div>

            <div class="form-group form__group" v-bind:class="{ 'is-invalid': errors.client_type }">
                <label class="form-label form__label">Покупаете</label>
                <select
                    class="form-control form-control--white"
                    v-model="contact.client_type">
                    <option :value="''">Выбрать</option>
                    <option :value="'personal'">Для себя</option>
                    <option :value="'company'">Для организации</option>
                </select>
                <p class="invalid-feedback" v-if="errors.client_type">
                    {{ errors.client_type.join(', ') }}
                </p>
            </div>

            <div class="form-group form__group" v-bind:class="{ 'is-invalid': errors.regular }">
                <label class="form-label form__label">
                    <input type="checkbox" v-model="contact.regular">&nbsp;Периодические покупки
                </label>
                <p class="invalid-feedback" v-if="errors.regular">
                    {{ errors.regular.join(', ') }}
                </p>
            </div>

            <div class="form-group form__group" v-bind:class="{ 'is-invalid': errors.regular }">
                <label class="form-label form__label"><strong>Интересна продукция</strong></label>
                <div class="form-group__checkboxes-group checkboxes-group">
                    <label class="form-label form__label checkboxes-group__item">
                        <input
                            type="checkbox"
                            :value="'Сейфы'"
                            v-model="priceParts.Сейфы">&nbsp;Сейфы
                    </label>
                    <label class="form-label form__label checkboxes-group__item">
                        <input
                            type="checkbox"
                            :value="'Шкафы'"
                            v-model="priceParts.Шкафы">&nbsp;Металлические шкафы и мебель
                    </label>
                    <label class="form-label form__label checkboxes-group__item">
                        <input
                            type="checkbox"
                            :value="'Стеллажи'"
                            v-model="priceParts.Стеллажи">&nbsp;Металлические Стеллажи
                    </label>
                    <label class="form-label form__label checkboxes-group__item">
                        <input
                            type="checkbox"
                            :value="'Гардеробные системы'"
                            v-model="priceParts['Гардеробные системы']">&nbsp;Гардеробные системы
                    </label>
                    <label class="form-label form__label checkboxes-group__item">
                        <input
                            type="checkbox"
                            :value="'Медицинское оборудование'"
                            v-model="priceParts['Медицинское оборудование']">&nbsp;Медицинское оборудование
                    </label>
                    <label class="form-label form__label checkboxes-group__item">
                        <input
                            type="checkbox"
                            :value="'Другое'"
                            v-model="priceParts['Другое']">&nbsp;Другое
                    </label>
                </div>
                
                <p class="invalid-feedback" v-if="errors.regular">
                    {{ errors.regular.join(', ') }}
                </p>
            </div>

            <div class="form__actions">
                <button type="button" class="btn btn-primary accept-btn modal__accept-btn w-100"
                    v-on:click="sendForm">Отправить</button>
                <p class="form-accept__text text-center mt-2">Отправляя вы принимаете <a href="/legal/">условия</a>
                    обработки персональных данных</p>
            </div>
        </div>

        <div v-if="step == 'complete'">
            <p class="text-success">
                Ваше сообщение успешно отправлено! Мы свяжемся с Вами в ближайшее время.
            </p>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueMask from 'v-mask'

import FormMixin from '../vue_mixins/FormMixin.vue'

Vue.use(VueMask)


export default {
    name: 'PriceRequestContact',
    mixins: [FormMixin],
    data() {
        return {
            contact: {},
            errors: {},
            step: 'form',
            priceParts: {
                'Сейфы': false,
                'Шкафы': false,
                'Стеллажи': false,
                'Гардеробные системы': false,
                'Медицинское оборудование': false,
                'Другое': false
            }
        }
    },

    mounted() {
        this.initData()
    },
    methods: {
        sendForm: function () {

            const entries = Object.entries(this.priceParts)
            let pricesText = ''

            entries.forEach(([key, value]) => {
                if (value) {
                    pricesText += ` - ${key}\n`
                }
            })

            this.contact.price_parts = pricesText

            axios.put("/contacts/api/price/", this.contact)
                .then(response => {
                    this.contact = response.data
                    this.step = 'complete'
                    ym(this.ymCounterId, 'reachGoal', 'PRICE_MESSAGE')
                })
                .catch(error => {
                    this.errors = error.response.data;
                });
        },

        initData() {
            axios.get("/contacts/api/price/").then(response => { this.contact = response.data })
            this.errors = {}
            this.step = 'form'
        }
    }
}
</script>

<style lang="scss"></style>
